require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./shiftplanning-software.json") })
        }
      }, "path---shiftplanning-software");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---shiftplanning-software!./.cache/json/shiftplanning-software.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---shiftplanning-software!./.cache/json/shiftplanning-software.json
// module chunks = 231608221292675